module.exports = __webpack_public_path__ + "img/49_13.d40d35b6.png";